import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotVideosSection from './components/HotVideosSection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';

const combinedSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '芒果视频',
      url: 'https://mangovideo.com/',
      description: '芒果视频提供1080P超清画质在线播放，电影电视剧全集免费高清观看，流畅不卡顿。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://mangovideo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '芒果视频',
      url: 'https://mangovideo.com/',
      description: '高清影视在线播放平台，提供1080P超清画质电影电视剧免费观看。',
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '芒果视频需要付费吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '芒果视频目前完全免费，所有电影、电视剧、综艺、动漫均可免费在线观看，无需任何会员费用。我们致力于为用户提供优质的免费高清观影体验。',
          },
        },
        {
          '@type': 'Question',
          name: '芒果视频的画质怎么样？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '芒果视频支持1080P超清画质在线播放，采用先进的视频编码技术和CDN加速，确保画面清晰流畅。无论是大屏电视还是手机观看，都能获得出色的视觉体验。',
          },
        },
        {
          '@type': 'Question',
          name: '为什么选择芒果视频？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '芒果视频拥有海量影视资源库，涵盖电影、电视剧、综艺、动漫、纪录片等多品类内容。我们以流畅不卡顿的播放体验和简洁美观的界面设计赢得了用户的信赖。',
          },
        },
        {
          '@type': 'Question',
          name: '芒果视频支持哪些设备观看？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '芒果视频支持电脑、平板、手机等多种设备在线观看。只需打开浏览器访问芒果视频，即可随时随地享受高清影视内容，无需下载任何APP。',
          },
        },
        {
          '@type': 'Question',
          name: '芒果视频的影片更新速度快吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的内容团队每日更新最新影视资源，热门电影、电视剧上线后第一时间同步更新。同时，经典老片库也在持续扩充中，满足不同用户的观影需求。',
          },
        },
        {
          '@type': 'Question',
          name: '观看过程中出现卡顿怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '芒果视频采用智能自适应码率技术，会根据您的网络状况自动调整画质。如遇卡顿，可以尝试切换至较低清晰度或检查网络连接。我们的服务器部署了全球CDN加速节点，确保各地区用户都能获得流畅的播放体验。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="芒果视频 - 香蕉视频与红桃视频高清替代 | 芒果视频1080P超清画质不缓冲在线看"
        description="芒果视频提供1080P超清画质在线播放，媲美香蕉视频、红桃视频等热门平台。电影电视剧全集免费高清观看，流畅不卡顿，搜索高清影视就来芒果视频。"
        keywords="芒果视频,芒果视频高清,芒果视频1080P,芒果视频超清,香蕉视频,红桃视频,高清在线观看,免费高清影视"
        canonicalUrl="https://mangovideo.com/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(combinedSchema) }}
      />

      <main>
        <HeroSection />
        <CategorySection />
        <HotVideosSection />
        <ArticlesSection />
        <FAQSection />
      </main>
    </>
  );
}